/* ==========================================================================
   Oakley Meta PDP — módulos para Shopify (Online Store 2.0)

   Diferencias respecto de la versión standalone:
   - Todo se inicializa por raíz de sección (.oom-pdp), no sobre document.
     Así funcionan varias instancias en la misma página y los IDs generados
     con {{ section.id }} no chocan.
   - Escucha shopify:section:load / :unload para re-inicializar cuando el
     personalizador vuelve a renderizar la sección.
   - Marca cada raíz con data-oom-init para no duplicar listeners.
   ========================================================================== */
(function () {
  "use strict";

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  };

  /* ---------------------------------------------------------------- sport --- */
  function initSportModule(root) {
    var track = $(".newSportModule_track", root);
    if (!track) return;

    var slides = $$(".newSportModule_slide", track);
    var prev = $(".pdpMetaBottom_newmetasport_prev", root);
    var next = $(".pdpMetaBottom_newmetasport_next", root);
    var dotsWrap = $(".nsm_pagination", root);
    if (!dotsWrap) return;

    dotsWrap.innerHTML = "";
    var dots = slides.map(function (slide, i) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", "Ir al slide " + (i + 1));
      dot.addEventListener("click", function () {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: "smooth" });
      });
      dotsWrap.appendChild(dot);
      return dot;
    });

    function currentIndex() {
      var closest = 0, min = Infinity;
      slides.forEach(function (slide, i) {
        var d = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < min) { min = d; closest = i; }
      });
      return closest;
    }

    function sync() {
      var i = currentIndex();
      dots.forEach(function (dot, di) { dot.classList.toggle("is-active", di === i); });
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= maxScroll - 1;
      if (prev) { prev.classList.toggle("is-disabled", atStart); prev.disabled = atStart; }
      if (next) { next.classList.toggle("is-disabled", atEnd); next.disabled = atEnd; }
    }

    function step(dir) {
      var w = slides[0] ? slides[0].getBoundingClientRect().width + 12 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: "smooth" });
    }

    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
    track.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  }

  /* -------------------------------------------------------------- flyouts --- */
  function initFlyouts(root) {
    var lastFocused = null;

    function open(wrapper) {
      lastFocused = document.activeElement;
      wrapper.classList.add("is-open");
      $(".oo_flyout-overlay-container", wrapper).setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      $$("video[data-src], img[data-src]", wrapper).forEach(function (el) {
        el.src = el.getAttribute("data-src");
        el.removeAttribute("data-src");
        if (el.tagName === "VIDEO") {
          el.muted = true;
          el.loop = true;
          el.setAttribute("playsinline", "");
          el.play().catch(function () {});
        }
      });
      var closeBtn = $(".oo_flyout-overlay-close-icon", wrapper);
      if (closeBtn) closeBtn.focus();
    }

    function close(wrapper) {
      wrapper.classList.remove("is-open");
      $(".oo_flyout-overlay-container", wrapper).setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      $$("video", wrapper).forEach(function (v) { v.pause(); });
      if (lastFocused) lastFocused.focus();
    }

    $$("[data-flyoutid]", root).forEach(function (trigger) {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        // El id lleva sufijo {{ section.id }}, así que se busca en el documento.
        var wrapper = document.getElementById(trigger.getAttribute("data-flyoutid"));
        if (wrapper) open(wrapper);
      });
    });

    $$(".oo_flyout-overlay-wrapper", root).forEach(function (wrapper) {
      $(".oo_flyout-overlay-close-icon", wrapper)
        .addEventListener("click", function () { close(wrapper); });
      $(".oo_flyout-overlay-background", wrapper)
        .addEventListener("click", function () { close(wrapper); });
    });

    root.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var openWrapper = $(".oo_flyout-overlay-wrapper.is-open", root);
      if (openWrapper) close(openWrapper);
    });
  }

  /* ---------------------------------------------------------------- video --- */
  function initVideoComponents(root) {
    $$(".oom-video-component", root).forEach(function (comp) {
      var video = $("video.oom-video-media", comp);
      if (!video) return;
      var progress = $(".oom-progress-bar", comp);
      var playBtn = $(".oom-video-controls_status.play", comp);
      var pauseBtn = $(".oom-video-controls_status.pause", comp);

      function pickSource() {
        var isMobile = window.innerWidth < 992;
        var src = isMobile
          ? video.getAttribute("data-videomobileurl")
          : video.getAttribute("data-videodesktopurl");
        var poster = isMobile
          ? video.getAttribute("data-postermobileurl")
          : video.getAttribute("data-posterdesktopurl");
        if (poster) video.poster = poster;
        if (src && video.currentSrc !== src && video.getAttribute("src") !== src) {
          video.src = src;
        }
      }
      pickSource();
      window.addEventListener("resize", pickSource);

      video.muted = true;
      comp.classList.add("is-paused");

      video.addEventListener("play", function () { comp.classList.remove("is-paused"); });
      video.addEventListener("pause", function () { comp.classList.add("is-paused"); });
      video.addEventListener("timeupdate", function () {
        if (progress && video.duration) {
          progress.value = (video.currentTime / video.duration) * 100;
        }
      });

      function toggle() {
        if (video.paused) video.play().catch(function () {});
        else video.pause();
      }
      if (playBtn) playBtn.addEventListener("click", toggle);
      if (pauseBtn) pauseBtn.addEventListener("click", toggle);

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) video.play().catch(function () {});
            else video.pause();
          });
        }, { threshold: 0.35 }).observe(video);
      }
    });
  }

  /* ------------------------------------------------------------- features --- */
  function initFeaturesSlider(root) {
    var track = $(".pdp_features_track", root);
    if (!track) return;

    var slides = $$(".pdp_feature_slide", track);
    var prev = $(".pdpMetaBottom_features_prev", root);
    var next = $(".pdpMetaBottom_features_next", root);
    var dots = $$(".pdpMetaBottom_features_pagination_elem", root);
    var index = 0;
    var mq = window.matchMedia("(max-width: 991px)");

    function render() {
      if (!mq.matches) {
        track.style.transform = "";
        slides.forEach(function (slide) {
          var info = $(".lxTeaser-infotext", slide);
          if (info) info.style.opacity = "";
          slide.removeAttribute("aria-hidden");
        });
        return;
      }
      var offset = slides[index].offsetLeft - slides[0].offsetLeft;
      track.style.transform = "translateX(" + -offset + "px)";
      slides.forEach(function (slide, i) {
        var info = $(".lxTeaser-infotext", slide);
        if (info) info.style.opacity = i === index ? "1" : "0";
        slide.setAttribute("aria-hidden", i === index ? "false" : "true");
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle("active", i === index);
        dot.setAttribute("aria-current", i === index ? "true" : "false");
      });
      if (prev) {
        prev.classList.toggle("is-disabled", index === 0);
        prev.disabled = index === 0;
      }
      if (next) {
        var last = index === slides.length - 1;
        next.classList.toggle("is-disabled", last);
        next.disabled = last;
      }
    }

    function go(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      render();
    }

    if (prev) prev.addEventListener("click", function () { go(index - 1); });
    if (next) next.addEventListener("click", function () { go(index + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function (e) { e.preventDefault(); go(i); });
    });

    var startX = null;
    track.addEventListener("touchstart", function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener("touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) go(index + (dx < 0 ? 1 : -1));
      startX = null;
    });

    window.addEventListener("resize", render);
    render();
  }

  /* --------------------------------------------------------------- social --- */
  function initSocialModule(root) {
    var module = $(".ct_cm--SMV2", root);
    if (!module) return;

    var tabs = $$(".ct_cm__anchors li", module);
    if (!tabs.length) return;
    var buttons = tabs.map(function (li) { return $(".ct_cm__anchor", li); });
    var bars = tabs.map(function (li) { return $(".ct_cm__progress", li); });
    var videos = $$(".ct_cm__videos__container video", module);
    var texts = $$(".ct_cm__text__container", module);
    var togglePlay = $(".ct_cm__togglePlay", module);
    var toggleVolume = $(".ct_cm__toggleVolume", module);
    var announcer = $(".ct_cm__announcement", module);
    var index = 0, muted = true, paused = false;

    function activate(i, autoplay) {
      index = (i + videos.length) % videos.length;
      tabs.forEach(function (li, n) { li.classList.toggle("active", n === index); });
      buttons.forEach(function (btn, n) {
        btn.setAttribute("aria-selected", n === index ? "true" : "false");
        btn.tabIndex = n === index ? 0 : -1;
      });
      bars.forEach(function (bar, n) {
        if (n !== index) bar.style.transform = "scaleX(0)";
      });
      texts.forEach(function (t, n) { t.classList.toggle("active", n === index); });
      videos.forEach(function (v, n) {
        v.classList.toggle("active", n === index);
        if (n !== index) { v.pause(); v.currentTime = 0; }
      });
      var current = videos[index];
      if (!current.src && current.getAttribute("data-src")) {
        current.src = current.getAttribute("data-src");
      }
      current.muted = muted;
      if (autoplay !== false && !paused) current.play().catch(function () {});
      if (announcer) {
        announcer.textContent = "New content loaded: " + (index + 1) + " of " + videos.length;
      }
    }

    videos.forEach(function (video, n) {
      video.muted = true;
      video.addEventListener("timeupdate", function () {
        if (n !== index || !video.duration) return;
        bars[n].style.transform = "scaleX(" + video.currentTime / video.duration + ")";
      });
      video.addEventListener("ended", function () {
        if (n === index) activate(index + 1);
      });
    });

    buttons.forEach(function (btn, n) {
      btn.addEventListener("click", function () {
        paused = false;
        if (togglePlay) togglePlay.classList.add("ct_cm__playing");
        activate(n);
      });
      btn.addEventListener("keydown", function (e) {
        var dir = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var target = (n + dir + buttons.length) % buttons.length;
        buttons[target].focus();
        activate(target);
      });
    });

    if (togglePlay) {
      togglePlay.addEventListener("click", function () {
        paused = !paused;
        togglePlay.classList.toggle("ct_cm__playing", !paused);
        togglePlay.setAttribute("aria-label", paused ? "play video" : "pause video");
        if (paused) videos[index].pause();
        else videos[index].play().catch(function () {});
      });
    }

    if (toggleVolume) {
      toggleVolume.addEventListener("click", function () {
        muted = !muted;
        toggleVolume.classList.toggle("ct_cm__muted", muted);
        videos.forEach(function (v) { v.muted = muted; });
      });
    }

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !paused) videos[index].play().catch(function () {});
          else videos[index].pause();
        });
      }, { threshold: 0.3 }).observe(module);
    }

    activate(0, false);
  }

  /* ----------------------------------------------------------- acordeones --- */
  function initAccordions(root) {
    function syncOne(input) {
      var expanded = input.checked;
      var content = document.getElementById(input.getAttribute("aria-controls"));
      input.setAttribute("aria-expanded", expanded ? "true" : "false");
      if (content) {
        content.setAttribute("aria-hidden", expanded ? "false" : "true");
        if (expanded) content.removeAttribute("inert");
        else content.setAttribute("inert", "");
      }
      var box = input.closest(".accordionBox");
      if (box) {
        $$(".accordionBox-label", box).forEach(function (label) {
          label.setAttribute("aria-expanded", expanded ? "true" : "false");
        });
      }
    }

    $$(".accordionBox-input", root).forEach(function (input) {
      input.addEventListener("change", function () { syncOne(input); });
      syncOne(input);
    });

    $$(".accordionBox-label", root).forEach(function (label) {
      var id = label.getAttribute("data-target-input");
      label.addEventListener("keydown", function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        e.preventDefault();
        var input = document.getElementById(id);
        if (input) input.click();
      });
    });
  }

  /* ------------------------------------------------------------------------ */
  // Registro de raíces ya inicializadas. Se usa un WeakSet en vez de un
  // atributo en el DOM porque el atributo viaja con el HTML si el tema o una
  // app clona los nodos, y entonces la copia nunca se inicializaría.
  var initialized = new WeakSet();

  function initRoot(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    initSportModule(root);
    initFlyouts(root);
    initVideoComponents(root);
    initFeaturesSlider(root);
    initSocialModule(root);
    initAccordions(root);
  }

  function initAll(scope) {
    $$(".oom-pdp", scope || document).forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }

  // Personalizador de temas: la sección se reemplaza en el DOM al editarla.
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:section:unload", function () {
    // Los nodos se descartan, no hay nada que limpiar en ellos; solo se
    // libera el scroll del body por si quedó un modal abierto.
    document.body.style.overflow = "";
  });
})();
